import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import Loader from 'src/components/Loader';
import { Trans } from 'react-i18next';
import SelectBox from './SelectBox';

const underlineOccurences = (label, q) => (
  <span
    dangerouslySetInnerHTML={{
      __html: label.replace(new RegExp(`(${q})`, 'gi'), '<u>$1</u>'),
    }}
  />
);

const NoOptionsMessage = props => {
  if (props.selectProps.inputValue.length >= 3) {
    return <components.NoOptionsMessage {...props} />;
  }
  return (
    <components.NoOptionsMessage {...props}>
      <Trans>TYPE_SOMETHING_TO_SEARCH</Trans>
    </components.NoOptionsMessage>
  );
};

NoOptionsMessage.propTypes = {
  selectProps: PropTypes.shape({
    inputValue: PropTypes.string,
  }),
};

const Option = props => (
  <components.Option {...props}>
    {underlineOccurences(props.label, props.selectProps.inputValue)}
  </components.Option>
);

Option.propTypes = {
  label: PropTypes.string,
  selectProps: PropTypes.shape({
    inputValue: PropTypes.string,
  }),
};

const LoadingMessage = props => (
  <components.LoadingMessage {...props}>
    <Loader withText={false} />
  </components.LoadingMessage>
);

const AsyncSelectBox = ({ filter, options, ...rest }) => (
  <SelectBox
    components={{
      NoOptionsMessage,
      LoadingIndicator: null,
      LoadingMessage,
      Option,
    }}
    options={filter ? options.filter(filter) : options}
    {...rest}
  />
);

AsyncSelectBox.propTypes = {
  filter: PropTypes.func,
  options: PropTypes.array,
};

AsyncSelectBox.defaultProps = {
  filter: null,
  options: [],
};

export default React.memo(AsyncSelectBox);
